import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PageEvent } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';
import { BubbleDataPoint, Chart, Point } from 'chart.js';
import { addDays, format } from 'date-fns';
import { es } from 'date-fns/locale';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { environment } from "./../../../../environments/environment";
import { UserDataService } from 'src/app/services/user-data.service';
import { BeerConsumptionService } from 'src/app/services/beer-consumption.service';
import { BeerConsumptionWeekService } from 'src/app/services/beer-consumption-week.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import zoomPlugin from 'chartjs-plugin-zoom';

const moment = require('moment');
//import zoomPlugin from 'chartjs-plugin-zoom';
interface Establecimientos{
  value: number;
  name: string;
}
interface DatosTanque {
  deviceId: number;
  slot: number;
  consumo: number;
}
@Component({
  selector: 'app-home-establecimientos',
  templateUrl: './home-establecimientos.component.html',
  styleUrls: ['./home-establecimientos.component.css']
})
export class HomeEstablecimientosComponent {

  //ESTABLECIMIENTOS
  establecimientos: any;
  establecimientosOriginales: any;
  establecimientosConAlarmas: any [] = [];
  establecimientosConAlarmasNivel: any = [];
  litrosConsumidosPorEstablecimiento: { [key: string]: number | undefined } = {};
  consumosPorTipoDeCervezaEnEstablecimiento: any = [];
  expandedState: { [key: number]: boolean } = {};
  rakingEstablecimientosCambiadaCargarda: boolean = false;
  consumosPorHorasCargado: boolean = false;
  //DISPOSITIVOS
  dispositivos: any;
  devicesReferences: string = ""; //Referencias de todos los dispositivos
  noHayLecturas: any [] = [];

  //ALARMAS
  nAlarmas: number = 0;
  nAlarmasSinPresion: number = 0;

  //FECHA
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate();
  mes: number = this.fechaActual.getMonth();
  anio: number = this.fechaActual.getFullYear();
  nombresMeses: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  nombreMes: string = this.nombresMeses[this.mes];
  sFechaActual: string = this.dia+ " de " +this.nombreMes+ " de " +this.anio;
  mes1 = this.mes + 1;
  fechaActualString: string = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${this.dia.toString().padStart(2, '0')}`;

  //RELOJ
  time = new Date();
  intervalReloj: any;

  //CONTADORES
  contadorAlarmaTemperatura = 0
  contadorAlarmaNivel = 0
  contadorAlarmaConexion = 0
  contadorAlarmaPresion = 0
  contadorOtras = 0
  nEstablecimientos: number = 0; //Número de establecimientos que el usuario puede visualizar

  //CERVEZAS
  cervezas: any;

  //RITMO CONSUMOS
  private ritmosConsumoSubscription: Subscription | undefined;

  //USUARIO
  userData: any;

  //TANQUES
  litrosConsumidosPorTanque: DatosTanque[] = [];

  //CONSUMO DIA ACTUAL
  consumoDiaActual: any = [];
  consumoDiaActualPorTipo: any = [];
  consumoMesActualPorTipo: any = [];
  consumoAnioActualPorTipo: any = [];
  consumoDiaActualTotal = 0;
  consumoAnioActualTotal = 0;
  consumoMesActualTotal = 0;

  //DIA DE MAYOR CONSUMO
  maxConsumptionWeekDay: any;
  maxConsumptionWeekDayDetallado: any;
  maxConsumptionMonthDay: any;
  maxConsumptionMonthDayDetallado: any;
  maxConsumptionYearDay: any;
  maxConsumptionYearDayDetallado: any;
  private maxConsumptionWeekDaySubscription: Subscription | undefined;
  private maxConsumptionMonthDaySubscription: Subscription | undefined;
  private maxConsumptionYearDaySubscription: Subscription | undefined;
  

  //SEMANA DE MAYOR CONSUMO
  maxConsumptionMonthWeek: any;
  maxConsumptionMonthWeekDetallado: any;
  maxConsumptionYearWeek: any;
  maxConsumptionYearWeekDetallado: any;
  maxConsumptionPreviusYearWeek: any;
  maxConsumptionPreviusYearWeekDetallado: any;
  private maxConsumptionMonthWeekSubscription: Subscription | undefined;
  private maxConsumptionYearWeekSubscription: Subscription | undefined;
  private maxConsumptionPreviusYearWeekSubscription: Subscription | undefined;

  //URL
  urlBase: string = "";

  //ERRORES
  errorMessage : string ="";

  //CARGA DE DATOS
  datosRecibidos: boolean = false;
  intervalId: any;
  intervaloSegundos = 15;
  actualizacion: boolean = false;

  // GRÁFICAS
  spanGaps: number = 1000 * 60 * 25; //25 minutos
  chartRanking: any;
  chartConsumoHoras: any;
  consumoTotalesTotalesPorCerveza: { type: string; consumo: number }[] = [];
  rankingData1: RankingEstablecimientos1[] = [];
  topRankingData1: RankingEstablecimientos1[] = [];
  rankingEstablecimientosDatos: boolean = true;
  consumosHorasDatos: boolean = true;
  private rankingSubscription: Subscription | undefined;
  private consumoHorasSubscription: Subscription | undefined;

    //DISPOSITIVO
    devicesReferencesHistorico: string = "";

    //HISTORICO
      charts: any [] = [];
      chartsDispositivo: any[] = []; //Charts de cada dispositivo

    //CARGA DE DATOS
      tamañoDeLecturas: any[] = [];
      graficasCargadas: boolean = false;

    //SUBSCRIPCIONES
      private pedidosSubscription: Subscription | undefined;
      private recargasSubscription: Subscription | undefined;

  //SUBSCRIPCIONES
  private establecimientosSubscription: Subscription | undefined;
  private cervezasSubscription: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;
  private historicoDiaPorTipoSubscription : Subscription | undefined;

  constructor(private deviceService: DeviceService, private error429: Error429Service,
    private dialog: MatDialog, private userDataService: UserDataService, private beerService: BeerConsumptionService, private beerWeekService: BeerConsumptionWeekService){
    this.urlBase = environment.urlNonce;
    this.userData = this.userDataService.getUserData();
    // console.log("Pro_Id", this.userData.pro_id)
  }

  ngOnInit(): void {
    this.cargarTodosLosEstablecimientos(this.actualizacion);
    this.intervalReloj = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    clearInterval(this.intervalReloj);
    if (this.establecimientosSubscription) {
      this.establecimientosSubscription.unsubscribe();
    } 
    if (this.cervezasSubscription) {
      this.cervezasSubscription.unsubscribe();
    } 
    if (this.historicoDiaSubscription) {
      this.historicoDiaSubscription.unsubscribe();
    } 
    if (this.historicoDiaPorTipoSubscription) {
      this.historicoDiaPorTipoSubscription.unsubscribe();
    }
    if (this.rankingSubscription) {
      this.rankingSubscription.unsubscribe();
    } 
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    } 
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
  }

  cargarTodosLosEstablecimientos(actualizacion: boolean){
    this.establecimientosSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next: async resp =>{
        const establecimientosFiltrados = [];
        // if(this.establecimientosFiltradosBoolean){
        //   for(let i=0; i<resp.length; i++){
        //     const filtrado = this.establecimientos.some((establecimiento:any) => establecimiento.id === resp[i].id);
        //     if(filtrado){
        //       establecimientosFiltrados.push(resp[i]);
        //     }
        //   }
        //   this.establecimientos = establecimientosFiltrados;
        // } else {
        this.establecimientos = resp;
        //Excluir los establecimientos que no estén activos
        this.establecimientos = this.establecimientos.filter((establecimiento:any) => establecimiento.status === 1);
        // }
        // this.establecimientos = this.establecimientos.filter((establecimiento:any) => establecimiento.id !== 15); //ELIMINAR MERCADO CANALEJAS DEL HOME
        //Calcular numero de alarmas
        this.establecimientos.forEach((establecimiento: any) => {
          /*ALARMAS*/
          const nuevasAlarmas = {
            desconectados: this.nAlarmaDesconectado(establecimiento.id),
            tarjetaSD: this.nAlarmaTarjetaSD(establecimiento.id),
            powerOff: this.nAlarmaPowerOff(establecimiento.id),
            powerOn: this.nAlarmaPowerOn(establecimiento.id),
            nivel: this.nAlarmaNivel(establecimiento.id),
            temperaturaAlta: this.nAlarmaTemperaturaAlta(establecimiento.id),
            temperaturaBaja: this.nAlarmaTemperaturaBaja(establecimiento.id),
            presionAlta: this.nAlarmaPresionAlta(establecimiento.id),
            presionBaja: this.nAlarmaPresionBaja(establecimiento.id),
          };
          // Comparar las nuevas alarmas con las existentes antes de asignar, si son iguales no se añaden
          if (!this.sonIguales(establecimiento.nAlarmas, nuevasAlarmas)) {
            establecimiento.nAlarmas = nuevasAlarmas;
          }
          establecimiento.devices.sort((a:any, b:any) => { // Ordenar los dispositivos por label
            if (a.dev_label < b.dev_label) return -1; 
            if (a.dev_label > b.dev_label) return 1;
            return 0;
          });
        });
        this.nEstablecimientos = this.establecimientos.length;
        this.calcularDispositivos();
        this.calcularAlarmas();
        await this.calcularConsumoDiarioDelDiaActual();
        this.calcularConsumoPorCerveza();
        this.establecimientos.forEach((establecimiento: any) => {
          establecimiento.ultimaLectura = this.devolverUltimaLecturaEstablecimiento(establecimiento.id, false);
        });
        //Solo cargar los datos de las cervezas en la primera llamada para evitar lanzar demasiadas llamadas
        this.establecimientosOriginales = this.establecimientos;
        await this.cargarDatosCervezasYEstablecimientosEnPagina();
        await this.getConsumoActualPorTipoMesActual();
        await this.getConsumoActualPorTipoAñoActual();
        this.getDiaSemanaActualMayorConsumo();
        this.getDiaMesActualMayorConsumo();
        this.getDiaAnioActualMayorConsumo();
        this.getSemanaMesActualMayorConsumo();
        this.getSemanaAnioActualMayorConsumo();
        this.getSemanaAnioAnteriorMayorConsumo();
        await this.getConsumoActualPorTipoDiaActual();
        this.loadChartConsumoPorHora();
        this.loadChartTopEstablecimientos();
        this.datosRecibidos = true;
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        
      }
    });
  }

  calcularConsumoPorCerveza(){
    for(let i=0; i<this.establecimientos.length; i++){
      const filtterConsumos = this.consumoDiaActual.filter((consumosEstablecimiento: any)=> consumosEstablecimiento.establecimientoId ==  this.establecimientos[i].id);
      // Calcular consumos por tanques
      let consumosTanque: any = [];
      for(let j=0; j<filtterConsumos.length; j++){
        for (let z = 1; z <= 4; z++) {
          const tanqueKey = `tanque${z}`;
          consumosTanque.push({
            cervezaID: filtterConsumos[j].tanques[tanqueKey].cervezaId,
            consumo: filtterConsumos[j].tanques[tanqueKey].consumo,
          });
        }
      }
      // Calcular consumos por cerveza
      const consumosPorCerveza: any[] = [];
      consumosTanque.forEach((tanque: any) => {
        if (tanque.cervezaID !== null) {
          const index = consumosPorCerveza.findIndex(item => item.cervezaID === tanque.cervezaID);
          if (index !== -1) {
            consumosPorCerveza[index].consumo += tanque.consumo;
          } else {
            consumosPorCerveza.push({
              cervezaID: tanque.cervezaID,
              consumo: tanque.consumo,
            });
          }
        }
      });

      // Datos por establecimiento
      this.consumosPorTipoDeCervezaEnEstablecimiento.push({
        establecimientoID: this.establecimientos[i].id,
        consumosPorTanque: consumosTanque,
        consumosPorCervezas: consumosPorCerveza,
      });
    }
  }

  devolverConsumoPorTipoDeCervezaEnEstablecimiento(establecimientoID: number, cervezaID: number) {
    const consumosEnEstablecimiento = this.consumosPorTipoDeCervezaEnEstablecimiento.find(
      (consumos: any) => consumos.establecimientoID === establecimientoID
    );
    if (consumosEnEstablecimiento) {
      const consumoPorCerveza = consumosEnEstablecimiento.consumosPorCervezas.find(
        (consumo: any) => consumo.cervezaID === cervezaID
      );
      return consumoPorCerveza ? this.soloDosDecimalesConComa(consumoPorCerveza.consumo): 0;
    } else {
      return 0;
    }
  }

  cambiarIntervalo(nuevoIntervalo: number) {
    this.intervaloSegundos = nuevoIntervalo;
  }

  sonIguales(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  obtenerDiaSiguiente(diaActual: string): string {
    const fechaObjeto = new Date(diaActual);
    const diaSiguiente = addDays(fechaObjeto, 1);
    return diaSiguiente.toISOString().slice(0, 10);
  }

  calcularDispositivos() {
    let dispositivos: any[] = [];
    for (let i = 0; i < this.establecimientos.length; i++) {
        for (let j = 0; j < this.establecimientos[i].devices.length; j++) {
            const dispositivo = this.establecimientos[i].devices[j];
            dispositivo.graficasCargadas = false;
            dispositivos.push(dispositivo);
        }
    }
    this.dispositivos = dispositivos;
  }

  calcularDevicesReferences(establecimientos: any){
    let devicesReferencesLista: any = [];
    for (let i = 0; i < establecimientos.length; i++) {
      const references: string[] = establecimientos[i].devices.map((device: { dev_reference: string }) => device.dev_reference);
      devicesReferencesLista = devicesReferencesLista.concat(references);
    }
    this.devicesReferences = devicesReferencesLista.join('-');
  }

  calcularDevicesReferencesHistoricos(establecimientos: any){
    let devicesReferencesLista: any = [];
    for (let i=0; i < establecimientos.length; i++) {
      const references: string[] = establecimientos[i].devices.map((device: { dev_reference: string }) => device.dev_reference);
      devicesReferencesLista = devicesReferencesLista.concat(references);
    }
    this.devicesReferencesHistorico = devicesReferencesLista.join('-');
  }

  /*CALCULAR CONSUMO POR ESTABLECIMIENTO Y POR TANQUE*/
    async calcularConsumoDiarioDelDiaActual(){
      this.calcularDevicesReferences(this.establecimientos);
      await this.calcularConsumoDiaActual();
      //Guardar el consumo por establecimiento en una lista
      this.establecimientos.forEach((establecimiento: any) => {
        const consumo = this.calcularConsumoTotalEnEstablecimiento(establecimiento.id);
        establecimiento.consumoDelDia = consumo;
        this.litrosConsumidosPorEstablecimiento[establecimiento.id] = Number(consumo);
      });
      this.calcularConsumoEnTanques();
    }

    calcularConsumoDiaActual(){
      this.consumoDiaActual = [];
      return new Promise<void>((resolve, reject) => {
        const diaSiguiente = this.obtenerDiaSiguiente(this.fechaActualString);
        this.historicoDiaSubscription = this.deviceService.getMultiHistoricRaw(this.devicesReferences, this.fechaActualString, diaSiguiente, "0").subscribe({
          next: resp => {
            const camposTanque1 = ['field11', 'field12', 'field20'];
            const camposTanque2 = ['field13', 'field14', 'field21'];
            const camposTanque3 = ['field15', 'field16', 'field22'];
            const camposTanque4 = ['field26', 'field27', 'field28'];
    
            for (let i = 0; i < resp.length; i++) {
              const tanques = {
                tanque1: this.obtenerDatosTanque(resp[i], camposTanque1, 'beer_type_id_1'),
                tanque2: this.obtenerDatosTanque(resp[i], camposTanque2, 'beer_type_id_2'),
                tanque3: this.obtenerDatosTanque(resp[i], camposTanque3, 'beer_type_id_3'),
                tanque4: this.obtenerDatosTanque(resp[i], camposTanque4, 'beer_type_id_4'),
              };

              const consumoTotal = this.calcularConsumoTotal([tanques.tanque1.consumo, tanques.tanque2.consumo, tanques.tanque3.consumo, tanques.tanque4.consumo]);
    
              this.consumoDiaActual.push({
                dispositivoId: resp[i].id,
                establecimientoId: resp[i].dev_est_id,
                tanques: tanques,
                consumoTotal: consumoTotal,
              });
            }
            resolve();
          },
          error: err => {
            reject(err);
          },
          complete: () => {},
        });
      });
    }

    getConsumoActualPorTipoDiaActual(){
      this.consumoDiaActualPorTipo = []; 
      this.consumoDiaActualTotal = 0;
      return new Promise<void>((resolve, reject) => {
        const diaSiguiente = this.obtenerDiaSiguiente(this.fechaActualString);
        this.historicoDiaPorTipoSubscription = this.deviceService
          .getMultiHistoricRaw(this.devicesReferences, this.fechaActualString, diaSiguiente, "0")
          .subscribe({
            next: (resp) => {
              const camposTanques = [
                { campos: ['field11', 'field12', 'field20'], tipo: 'beer_type_id_1' },
                { campos: ['field13', 'field14', 'field21'], tipo: 'beer_type_id_2' },
                { campos: ['field15', 'field16', 'field22'], tipo: 'beer_type_id_3' },
                { campos: ['field26', 'field27', 'field28'], tipo: 'beer_type_id_4' },
              ];

              for (let i = 0; i < resp.length; i++) {
                for (let tanque of camposTanques) {
                  const { cervezaId, consumo } = this.obtenerDatosTanque(resp[i], tanque.campos, tanque.tipo);
                  if (cervezaId) {
                    if (!this.consumoDiaActualPorTipo[cervezaId]) {
                      if (this.cervezas && Array.isArray(this.cervezas)) {
                        const cerveza = this.cervezas.find((cerveza: any) => cerveza.id === cervezaId);
                        this.consumoDiaActualPorTipo[cervezaId] = {
                          type: cerveza ? cerveza.name : "",
                          consume: 0,
                        };
                      }
                    }
                    this.consumoDiaActualPorTipo[cervezaId].consume += consumo;
                  }
                }
              }
              this.consumoDiaActualPorTipo = this.consumoDiaActualPorTipo.filter((item: any) => item !== undefined);
              this.consumoDiaActualTotal = this.consumoDiaActualPorTipo.reduce(
                (total: any, item: any) => total + item.consume, 0
              );
              
            },
            error: (err) => {
              reject(err);
            },
            complete: () => {
              resolve();
            },
          });
      }); 
    }

    obtenerPrimerYUltimoDiaMes(fechaString: string): { primerDia: string; ultimoDia: string } {
      const fecha = new Date(fechaString);
    
      const primerDia = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
      const ultimoDia = new Date();
    
      return {
        primerDia: this.formatearFechaUTC(primerDia),
        ultimoDia: this.formatearFechaUTC(ultimoDia),
      };
    }

    obtenerPrimerYUltimoDiaAnio(fechaString: string): { primerDia: string; ultimoDia: string } {
      const fecha = new Date(fechaString);
    
      const primerDia = new Date(fecha.getFullYear(), 0, 1);
      
      const ultimoDia = new Date();
    
      return {
        primerDia: this.formatearFechaUTC(primerDia),
        ultimoDia: this.formatearFechaUTC(ultimoDia),
      };
    }
    
    formatearFechaUTC(fecha: Date): string {
      return new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()))
        .toISOString()
        .split("T")[0];
    }   

    getConsumoActualPorTipoMesActual(){
      this.consumoMesActualPorTipo = []; 
      this.consumoMesActualTotal = 0;
      return new Promise<void>((resolve, reject) => {
        const { primerDia, ultimoDia } = this.obtenerPrimerYUltimoDiaMes(this.fechaActualString);
        let cervezasIds = this.cervezas.map((obj: any) => obj.id);
        const establecimientoData = new FormData();
        establecimientoData.append('start', primerDia);
        establecimientoData.append('end', ultimoDia);
        // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
        establecimientoData.append('paises', JSON.stringify(["España"]));
        establecimientoData.append('desglose', "total");
        this.deviceService.getEstConsumos(establecimientoData).subscribe({
          next: resp =>{  
            if(resp.length > 0){
              const beerTypes = resp[0].beertypes;

              for (const key in beerTypes) {
                if (beerTypes.hasOwnProperty(key)) {
                  this.consumoMesActualTotal += beerTypes[key].consume;
                }
              }
              for (const key in beerTypes) {
                if (beerTypes.hasOwnProperty(key)) {
                  this.consumoMesActualPorTipo.push({
                    type: beerTypes[key].type,
                    consume: beerTypes[key].consume
                  });
                }
              }
            }
          },error:err =>{
            console.log(err,'err');
          }, complete: () => {
            resolve(); 
          }
        });
      }); 
    }

    getConsumoActualPorTipoAñoActual(){
      this.consumoAnioActualPorTipo = []; 
      this.consumoAnioActualTotal = 0;

      return new Promise<void>((resolve, reject) => {
        const { primerDia, ultimoDia } = this.obtenerPrimerYUltimoDiaAnio(this.fechaActualString);
        let cervezasIds = this.cervezas.map((obj: any) => obj.id);
        const establecimientoData = new FormData();
        establecimientoData.append('start', primerDia);
        establecimientoData.append('end', ultimoDia);
        // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
        establecimientoData.append('paises', JSON.stringify(["España"]));
        establecimientoData.append('desglose', "total");
        this.deviceService.getEstConsumos(establecimientoData).subscribe({
          next: resp =>{  
            if(resp.length > 0){
              const beerTypes = resp[0].beertypes;

              for (const key in beerTypes) {
                if (beerTypes.hasOwnProperty(key)) {
                  this.consumoAnioActualTotal += beerTypes[key].consume;
                }
              }
              for (const key in beerTypes) {
                if (beerTypes.hasOwnProperty(key)) {
                  this.consumoAnioActualPorTipo.push({
                    type: beerTypes[key].type,
                    consume: beerTypes[key].consume
                  });
                }
              }
            }
          },error:err =>{
            console.log(err,'err');
          }, complete: () => {
            resolve(); 
          }
        });
      }); 
    }

    getDiaSemanaActualMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('isoWeek').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().endOf('isoWeek').format('YYYY-MM-DDTHH:mm:ss'));
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "days");
      this.maxConsumptionWeekDaySubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{      
                this.maxConsumptionWeekDay = this.beerService.getMaxConsumptionDay(resp);
                this.maxConsumptionWeekDayDetallado = Object.keys(this.maxConsumptionWeekDay.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionWeekDay.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionWeekDay,'maxConsumptionWeekDay');
              }
            });
    }

    getDiaMesActualMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "days");
      this.maxConsumptionMonthDaySubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{     
                this.maxConsumptionMonthDay = this.beerService.getMaxConsumptionDay(resp);
                this.maxConsumptionMonthDayDetallado = Object.keys(this.maxConsumptionMonthDay.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionMonthDay.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionMonthDay,'maxConsumptionMonthDay');
              }
            });
    }

    obtenerRitmosConsumos(establecimientos: any){
      this.ritmosConsumoSubscription = this.deviceService.getRitmosConsumo().subscribe({
        next: resp =>{      
          console.log("RITMOS", resp)
          const consumptionRates = resp.consumptionRates;

          const consumptionMap = consumptionRates.reduce((acc: any, rate: any) => {
            acc[rate.tank_id] = {
              consumption_rate: rate.consumption_rate,
              prediction_days: rate.prediction_days
            };
            return acc;
          }, {});
        console.log("e", establecimientos)
          establecimientos.forEach((est: any) => {
            const tank = est.tankJson;
            const consumptionData = consumptionMap[tank.id];
        
            if (consumptionData) {
              tank.consumption_rate = consumptionData.consumption_rate;
              tank.prediction_days = consumptionData.prediction_days;
            }
          });

          if(this.userData.pro_id === 4){
            this.ordenarPorPreferencia(establecimientos)
          }else{
            establecimientos.forEach((est: { tankJson: { prediction_days: number; }; }) => {
              if (est.tankJson?.prediction_days < 0) {
                est.tankJson.prediction_days = 0;
              }
            });
            this.ordenarPorPreferencia(establecimientos)
          }
          // console.log("Establecimientos con ritmo de consumo", establecimientos);
        },error:err =>{
          console.log(err,'err');
        }, complete: () => {
          
        }
      });
    }
    
    getDiaAnioActualMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "days");
      this.maxConsumptionYearDaySubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{      
                this.maxConsumptionYearDay = this.beerService.getMaxConsumptionDay(resp);
                this.maxConsumptionYearDayDetallado = Object.keys(this.maxConsumptionYearDay.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionYearDay.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionYearDay,'maxConsumptionYearDay');
              }
            });
    }

    getExtraerPrimerAnio(rangoFechas: string): string {
      if (!rangoFechas) return 'Actual';
      const match = rangoFechas.match(/\d{2}\/\d{2}\/(\d{4})/);
      return match ? match[1] : '';
    }

    getExtraerPrimerAnioPasado(rangoFechas: string): string {
      if (!rangoFechas) return 'Anterior';
      const match = rangoFechas.match(/\d{2}\/\d{2}\/(\d{4})/);
      return match ? match[1] : '';
    }

    getExtraerDiaMes(rangoFechas: string): string {
      if (!rangoFechas) return '';
      const match = rangoFechas.match(/(\d{2}\/\d{2})\/\d{4} a (\d{2}\/\d{2})\/\d{4}/);
      return match ? `${match[1]} a ${match[2]}` : '';
    }

    extraerMes(rangoFechas: string | null | undefined): number {
      if (!rangoFechas) return 0;
      const match = rangoFechas.match(/\d{2}\/(\d{2})\/\d{4}/);
      return match ? parseInt(match[1], 10) : 0;
    }

    extraerDias(rangoFechas: string | null | undefined): string {
      if (!rangoFechas) return ''; 
      const match = rangoFechas.match(/(\d{2})\/\d{2}\/\d{4} a (\d{2})\/\d{2}\/\d{4}/);
      return match ? `${match[1]} a ${match[2]}` : '';
    }

    getRangoSemana(day: number | undefined, month: number, year: number) {

      if (!day || !month || !year) {
        return "Actual";
      }

      const date = new Date(year, month - 1, day);
      const dayOfWeek = date.getDay();

      const diffStart = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; 
      const diffEnd = diffStart + 6;
  
      const startDate = new Date(date);
      startDate.setDate(date.getDate() + diffStart);
  
      const endDate = new Date(date);
      endDate.setDate(date.getDate() + diffEnd);
  
      return `${startDate.getDate()} al ${endDate.getDate()}`;
  }

    getSemanaMesActualMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "weeks");
      this.maxConsumptionYearWeekSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{      
                this.maxConsumptionYearWeek = this.beerWeekService.getMaxConsumptionWeek(resp);
                this.maxConsumptionYearWeekDetallado = Object.keys(this.maxConsumptionYearWeek.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionYearWeek.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionYearWeek,'maxConsumptionYearWeek');
              }
            });
    }

    getSemanaAnioActualMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "weeks");
      this.maxConsumptionYearWeekSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{      
                this.maxConsumptionMonthWeek = this.beerWeekService.getMaxConsumptionWeek(resp);
                this.maxConsumptionMonthWeekDetallado = Object.keys(this.maxConsumptionMonthWeek.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionMonthWeek.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionMonthWeek,'maxConsumptionMonthWeek');
              }
            });
    }

    getSemanaAnioAnteriorMayorConsumo(){
      let cervezasIds = this.cervezas.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      // Obtener el inicio y fin del año anterior
      const lastYearStart = moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DDTHH:mm:ss');
      const lastYearEnd = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DDTHH:mm:ss');
      establecimientoData.append('start', lastYearStart);
      establecimientoData.append('end', lastYearEnd);
      // establecimientoData.append('cervezas', JSON.stringify(cervezasIds));
      establecimientoData.append('paises', JSON.stringify(["España"]));
      establecimientoData.append('desglose', "weeks");
      this.maxConsumptionPreviusYearWeekSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
              next: resp =>{      
                this.maxConsumptionPreviusYearWeek = this.beerWeekService.getMaxConsumptionWeek(resp);
                this.maxConsumptionPreviusYearWeekDetallado = Object.keys(this.maxConsumptionPreviusYearWeek.details).map(key => ({
                  type: key,
                  consume: this.maxConsumptionPreviusYearWeek.details[key]
                }));
              },error:err =>{
                console.log(err,'err');
              }, complete: () => {
                // console.log(this.maxConsumptionPreviusYearWeek,'maxConsumptionPreviusYearWeek');
              }
            });
    }

    formatearConsumo(consumoDiaActualTotal: number): string {
      let consumoRedondeado = Math.round(consumoDiaActualTotal);
      let consumoFormateado = consumoRedondeado.toLocaleString('es-ES');
      if (consumoRedondeado < 10000) {
        consumoFormateado = consumoRedondeado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

      return consumoFormateado;
    }

    calcularConsumoTotal(consumos: number[]): number {
      return parseFloat((consumos.reduce((total, consumo) => total + consumo, 0)).toFixed(2));
    }

    obtenerDatosTanque(respItem: any, camposTanque: string[], cervezaProp: string): { cervezaId: string | null; consumo: number } {
      return {
        cervezaId: respItem.readers_raw[0]?.[cervezaProp] || null,
        consumo: this.calcularConsumoTanque(respItem.readers_raw, camposTanque),
      };
    }

    obtenerDatosTanqueSinRaw(respItem: any, camposTanque: string[], cervezaProp: string): { cervezaId: string | null; consumo: number } {
      return {
        cervezaId: respItem.readers[0]?.[cervezaProp] || null,
        consumo: this.calcularConsumoTanque(respItem.readers, camposTanque),
      };
    }
    
    calcularConsumoTanque(readersRaw: any[], campos: string[]): number {
      let consumoTanque = 0;
      readersRaw.forEach(reader => {
        campos.forEach(campo => {
          if (reader && reader[campo] !== undefined) {
            consumoTanque += parseFloat(reader[campo] !== null ? reader[campo] : 0);
          } else {
            consumoTanque += 0;
          }
        });
      });
      return parseFloat(consumoTanque.toFixed(2));
    }

    calcularConsumoEnTanques() {
      this.consumoDiaActual.forEach((consumo: any) => {
        const { dispositivoId, tanques } = consumo;
        
        this.litrosConsumidosPorTanque.push({
          deviceId: dispositivoId,
          slot: 1,
          consumo: tanques.tanque1.consumo,
        });
        this.litrosConsumidosPorTanque.push({
          deviceId: dispositivoId,
          slot: 2,
          consumo: tanques.tanque2.consumo,
        });
        this.litrosConsumidosPorTanque.push({
          deviceId: dispositivoId,
          slot: 3,
          consumo: tanques.tanque3.consumo,
        });
        this.litrosConsumidosPorTanque.push({
          deviceId: dispositivoId,
          slot: 4,
          consumo: tanques.tanque4.consumo,
        });
      });
    }

    calcularConsumoTotalEnEstablecimiento(establecimientoId: number){
      let consumoTotalEstablecimiento = 0;
      // Filtrar los dispositivos pertenecientes al establecimiento
      const dispositivosEstablecimiento = this.consumoDiaActual.filter((dispositivo:any) => dispositivo.establecimientoId === establecimientoId);
      dispositivosEstablecimiento.forEach((dispositivo:any) => {
        consumoTotalEstablecimiento += dispositivo.consumoTotal;
      });
      return parseFloat(consumoTotalEstablecimiento.toFixed(2));
    }

    calcularDiasRestantes(nivelActual: number, ritmoConsumo: number){
      if (ritmoConsumo <= 0) {
        throw new Error("El ritmo de consumo debe ser mayor que cero.");
      }
    
      const diasRestantes = nivelActual / ritmoConsumo;
      return Math.round(diasRestantes * 10) / 10;
    }

  calcularAlarmas(){
    let establecimientosConAlarmas: any = [];
    let numeroAlarmas = 0;
    this.contadorAlarmaTemperatura = 0
    this.contadorAlarmaNivel = 0
    this.contadorAlarmaConexion = 0
    this.contadorAlarmaPresion = 0
    this.contadorOtras = 0
    this.calcularDispositivos();
    for(let i=0; i<this.establecimientos.length; i++){
      for(let j=0; j<this.establecimientos[i].alarms.length; j++){
        this.getContadorPorAlarma(this.establecimientos[i].alarms[j].type)
        numeroAlarmas ++;
        const tankJson = JSON.parse(this.establecimientos[i].alarms[j].tank);
        // const backgroundColor = this.getColorByTipoAlarma(this.establecimientos[i].alarms[j].type);
        let fieldNivel;
        if(tankJson){
          if(tankJson.slot == 1){
            fieldNivel = "field17"
          }
          if(tankJson.slot == 2){
            fieldNivel = "field18"
          }
          if(tankJson.slot == 3){
            fieldNivel = "field19"
          }
          if(tankJson.slot == 4){
            fieldNivel = "field25"
          }
        }
        establecimientosConAlarmas.push({
          desc: this.establecimientos[i].alarms[j].desc,
          desc2: this.establecimientos[i].alarms[j].desc2,
          device_id: this.establecimientos[i].alarms[j].device_id,
          device_name: this.devolverDispositivo(this.establecimientos[i].alarms[j].device_id).dev_label,
          device_reference: this.devolverDispositivo(this.establecimientos[i].alarms[j].device_id).dev_reference,
          device_lastReader: this.devolverDispositivo(this.establecimientos[i].alarms[j].device_id).lastreader,
          ended_at: this.establecimientos[i].alarms[j].ended_at,
          establishment_id: this.establecimientos[i].alarms[j].establishment_id,
          establishment_name: this.devolverEstablecimiento(this.establecimientos[i].id).est_name,
          establishment_external_id: this.devolverEstablecimiento(this.establecimientos[i].id).external_id,
          short: this.establecimientos[i].alarms[j].short,
          started_at: this.establecimientos[i].alarms[j].started_at,
          status: this.establecimientos[i].alarms[j].status,
          tank: this.establecimientos[i].alarms[j].tank,
          type: this.establecimientos[i].alarms[j].type,
          tankJson: tankJson,
          // backgroundColor: backgroundColor,
          fieldNivel: fieldNivel
        });
      }
    }
    this.nAlarmas = numeroAlarmas;
    this.nAlarmasSinPresion = numeroAlarmas - this.contadorAlarmaPresion
    this.establecimientosConAlarmas = establecimientosConAlarmas;
    this.establecimientosConAlarmasNivel = this.establecimientosConAlarmas.filter(item => item.type === 'L1' || item.type === 'L2' || item.type === 'L3' || item.type === 'L4' );
    // console.log("AlarmasNivel", this.establecimientosConAlarmasNivel)
  }

  cargarDatosCervezasYEstablecimientosEnPagina(){
    return new Promise<void>((resolve, reject) => {
      this.cervezasSubscription = this.deviceService.getBeerType().subscribe({
          next: resp => {
              this.cervezas = resp;
          },
          error: err => {
              if (err.status == 429) {
                  this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                  this.recargarPaginaDespuesDeTiempo();
                  reject("Error de peticiones demasiadas");
              } else {
                  this.errorMessage = err.error.message;
                  reject(err);
              }
          },
          complete: () => {
              
              resolve(); 
          }
      });
  });
  }

  soloDosDecimalesConComa(numero: number | undefined){
    if(Number.isNaN(numero)){
      return "0";
    } else {
      if(numero == undefined){
        return "0";
      } else {
        return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
      }
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Funciones para devolver un elemento

    devolverUltimaLecturaFormateada(fecha: string | undefined): string {
      if (!fecha) {
        return '--';
      }
      return format(new Date(fecha), 'dd-MM-yyyy HH:mm:ss');
    }

    devolverEstablecimiento(establecimientoId: number){
      const establecimiento = this.establecimientos.find((establecimiento:any) => establecimiento.id == establecimientoId);
      return establecimiento;
    }

    devolverDispositivo(dispositivoId: number){
      const dispositivo = this.dispositivos.find((dispositivo:any) => dispositivo.id == dispositivoId);
      return dispositivo;
    }

    devolverCeveza(cervezaId: number){
      const cerveza = this.cervezas.find((cerveza:any)=>cerveza.id == cervezaId);
      return cerveza;
    }

    devolverImagenCerveza(cervezaId: number){
      const cerveza = this.cervezas.find((cerveza:any)=>cerveza.id == cervezaId);
      const imagenCervezaURL = this.urlBase +'/uploads/imgs/'+ cerveza.img;
      return imagenCervezaURL;
    }

    devolverImagenEstablecimiento(establecimientoId: number){
      const establecimiento = this.establecimientos.find((establecimiento: any) => establecimiento.id == establecimientoId);
      return this.urlBase + "/uploads/imgs/"+ establecimiento.est_imgs;
    }

    devolverDireccionEstablecimiento(establecimientoId: number){
      const establecimiento = this.establecimientos.find((establecimiento: any) => establecimiento.id == establecimientoId);
      const direccion = 
        (establecimiento.address ? establecimiento.address + ", " : "") +
        (establecimiento.localidad ? establecimiento.localidad.name + ", " : "") +
        (establecimiento.localidad && establecimiento.localidad.administrative_area_level_2 ? establecimiento.localidad.administrative_area_level_2 + ", " : "") +
        (establecimiento.localidad && establecimiento.localidad.administrative_area_level_1 ? establecimiento.localidad.administrative_area_level_1 : "");
      return direccion;
    }

    devolverUltimaLecturaEstablecimiento(establecimientoId: number, formateada: boolean){
      let ultimaLectura: string | undefined;
      const establecimiento = this.establecimientos.find((establecimiento: any) => establecimiento.id == establecimientoId);
      for(let i=0; i<establecimiento.devices.length; i++){
        const device = establecimiento.devices[i];
        if (device.lastreader && device.lastreader.created_at) {
            if (!ultimaLectura || device.lastreader.created_at > ultimaLectura) {
                ultimaLectura = device.lastreader.created_at;
            }
        }
      }
      if(formateada){
        if(ultimaLectura){
          return this.devolverUltimaLecturaFormateada(ultimaLectura);
        } else {
          return '--';
        }
      } else {
        if(ultimaLectura){
          return ultimaLectura;
        } else {
          return '--';
        }
      }
    }

    calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId: number, tiposAlarma: string[]): number {
      let nAlarmas = 0;
      const establecimiento = this.devolverEstablecimiento(establecimientoId);
      if (establecimiento) {
          const alarmas = establecimiento.alarms.filter((alarma: any) => tiposAlarma.includes(alarma.type));
          nAlarmas = alarmas.length;
          return nAlarmas;
      }
      return nAlarmas;
    }
    
    nAlarmaNivel(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['L1', 'L2', 'L3', 'L4']);
    }

    nAlarmaDesconectado(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['OO']);
    }

    nAlarmaTarjetaSD(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['EE']);
    }

    nAlarmaPowerOff(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['TT']);
    }

    nAlarmaPowerOn(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['RR']);
    }

    nAlarmaTemperaturaBaja(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['B1', 'B2', 'B3', 'B4']);
    }

    nAlarmaTemperaturaAlta(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['A1', 'A2', 'A3', 'A4']);
    }

    nAlarmaPresionBaja(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['D1', 'D2', 'D3', 'D4']);
    }

    nAlarmaPresionAlta(establecimientoId: number): number {
        return this.calcularNumeroDeAlarmasPorTipoEstablecimiento(establecimientoId, ['C1', 'C2', 'C3', 'C4']);
    }

    getContadorPorAlarma(tipoAlarma: string) {
      const temperaturTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
      const presionTypes = ['D1', 'D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4'];
      const nivelConsumoTypes = ['L1', 'L2', 'L3', 'L4'];
      const dispositivoTypes = ['TT', 'EE'];
      const dispositivoDesconectado = ['OO'];
    
      if (temperaturTypes.includes(tipoAlarma)) {
        this.contadorAlarmaTemperatura ++;
      } else if (presionTypes.includes(tipoAlarma)) {
        this.contadorAlarmaPresion ++;
      } else if (nivelConsumoTypes.includes(tipoAlarma)) {
        this.contadorAlarmaNivel ++;
      } else if (dispositivoDesconectado.includes(tipoAlarma)) {
        this.contadorAlarmaConexion ++;
      }else if (dispositivoTypes.includes(tipoAlarma)) {
        this.contadorOtras ++;
      }
    }

    getAlarmasEnviarPorTipo(filter: string){
      const temperaturTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
      const presionTypes = ['D1', 'D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4'];
      const nivelConsumoTypes = ['L1', 'L2', 'L3', 'L4'];
      const dispositivoTypes = ['TT', 'EE'];
      const dispositivoDesconectado = ['OO'];
      
      if (filter === 'nivel') {
        return this.establecimientosConAlarmas.filter(alarma =>
          nivelConsumoTypes.includes(alarma.type)
        );
      } else if (filter === 'temperatura') {
        return this.establecimientosConAlarmas.filter(alarma =>
          temperaturTypes.includes(alarma.type)
        );
      } else if (filter === 'presion') {
        return this.establecimientosConAlarmas.filter(alarma =>
          presionTypes.includes(alarma.type)
        );
      } else if (filter === 'conexion') {
        return this.establecimientosConAlarmas.filter(alarma =>
          dispositivoDesconectado.includes(alarma.type)
        );
      }else if (filter === 'otras') {
        return this.establecimientosConAlarmas.filter(alarma =>
          dispositivoTypes.includes(alarma.type)
        );
      }else {
        return []
      }
    }

    getNombreMes(nDay: number): string {
      const meses = [
          "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
          "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      return meses[nDay - 1] || "Actual";
    }
  
  // DIALOGOS

    openDialog(enterAnimationDuration: string, exitAnimationDuration: string, consumos: any){
      this.deviceService.getBeerType().subscribe({
        next:resp =>{
          let cervezasData = resp;
          consumos.forEach((consumo: { type: any; img: any; img_mini: any; ulrImg: any; consume: any }) => {
            let cervezaEncontrada = cervezasData.find((cerveza: { name: any; }) => cerveza.name === consumo.type);
            consumo.consume = this.soloDosDecimalesConComa(consumo.consume);
            if (cervezaEncontrada) {
              consumo.img = cervezaEncontrada.img;
              consumo.img_mini = cervezaEncontrada.img_mini;
              consumo.ulrImg = this.urlBase +"/uploads/imgs/"+ cervezaEncontrada.img;
            }
          });
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete:()=>{
          this.dialog.open(ConsumoDetalladoDialog, {
            data: {
              consumos
            },
            width: '600px',
            enterAnimationDuration,
            exitAnimationDuration,
          });
        }
      });
    }

    // Se ordena teniendo en cuenta primero los días restantes y de segundo los ritmos de consumo
    ordenarPorPreferencia(establecimientosConAlarmasNivel: Establecimiento[]) {
      console.log("Okey", establecimientosConAlarmasNivel);
      return establecimientosConAlarmasNivel.sort((a, b) => {
        const predA = a.tankJson?.prediction_days ?? Infinity;
        const predB = b.tankJson?.prediction_days ?? Infinity;
        const rateA = a.tankJson?.consumption_rate ?? -Infinity;
        const rateB = b.tankJson?.consumption_rate ?? -Infinity;
    
        if (predA !== predB) {
          return predA - predB;
        }
    
        return rateB - rateA;
      });
    }

    async abrirDialogoRecargas(enterAnimationDuration: string, exitAnimationDuration: string){
      await this.obtenerRitmosConsumos(this.establecimientosConAlarmasNivel);

      // this.establecimientosConAlarmasNivel = await this.obtenerRitmosConsumos(this.establecimientosConAlarmasNivel);
      this.dialog.open(RecargasDialog, {
        data: {
          // tanquesConAlarmasNivel: ,
          tanquesConAlarmasNivel: this.establecimientosConAlarmasNivel,
          establecimientos: this.establecimientos,
          pro_id: this.userData.pro_id
        },
        width: '800px',
        enterAnimationDuration,
        exitAnimationDuration,
      });
    }

  //GRÁFICAS

    destroyChart(chartToRemove: Chart) {
      const indexToRemove = this.charts.indexOf(chartToRemove);
      if (indexToRemove !== -1) {
        chartToRemove.destroy();
      } else {
        // console.log('El gráfico no está en la lista.');
      }
    }

    resetZoomRanking(){
      if(this.chartRanking){
        this.chartRanking.resetZoom();
      }
    }

    resetZoomConsumos(){
      if(this.chartConsumoHoras){
        this.chartConsumoHoras.resetZoom();
      }
    }

    agruparConsumoPorHora(datos: any[]): any {
      return datos.reduce((resultado, item) => {
        const { hour, beertypes } = item;
        if (!resultado[hour]) {
          resultado[hour] = {};
        }
    
        Object.values(beertypes).forEach((beer: any) => {
          if (!resultado[hour][beer.type]) {
            resultado[hour][beer.type] = 0;
          }
          resultado[hour][beer.type] += beer.consume;
        });
    
        return resultado;
      }, {});
    }

    transformarDatosParaChart(datos: Record<number, Record<string, number>>): any {
      const labelsNumericos = Object.keys(datos).map(Number);
      const tiposCerveza = new Set<string>();

      Object.values(datos).forEach((consumo) => {
        Object.keys(consumo).forEach((tipo) => tiposCerveza.add(tipo));
      });
      const colores = [
        "rgb(251, 176, 64)",
        "#FFD540",
        "#FFDE7C",
      ];
      const datasets = Array.from(tiposCerveza).map((tipo, index) => ({
        label: tipo,
        backgroundColor: index < 2 ? colores[index] : colores[2], 
        borderWidth: 0,
        data: labelsNumericos.map((dia) => datos[dia]?.[tipo] || 0) 
      }));

      const labels = labelsNumericos.map(num => String(num).padStart(2, '0'));

      return { labels, datasets };
    }

    loadChartConsumoPorHora(){
      Chart.register(zoomPlugin);
      this.consumosPorHorasCargado = false;
      this.destroyChart(this.chartConsumoHoras);
      let establecimientosIds = this.establecimientos.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('establecimientos', JSON.stringify(establecimientosIds));
      establecimientoData.append('desglose', "hours");

      this.consumoHorasSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
        next: resp =>{      
          // const filteredData = resp.filter((item: { hour: number; beertypes: any[]; }) => 
          //   item.hour === 5 && Object.values(item.beertypes).some(beer => beer.consume !== 0)
          // );
          
          // console.log("Buscando",filteredData);
          if(resp.length == 0){
            this.consumosHorasDatos = false;
          } else {
            this.consumosHorasDatos = true;
          }
          setTimeout(() => {
            if(this.consumosHorasDatos){
              const canvasConsumos: any = document.getElementById('Consumos');
                if(canvasConsumos){
                  const ctxConsumos = canvasConsumos.getContext('2d');
                  const consumosPorHora = this.agruparConsumoPorHora(resp)
                  const data = this.transformarDatosParaChart(consumosPorHora)
                  const soloDosDecimalesConComa = (numero: any) => {
                    return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
                  };
                  let delayed: any;
                  if (this.chartConsumoHoras) {
                    this.chartConsumoHoras.destroy();
                  }
                  this.chartConsumoHoras = new Chart(ctxConsumos, {
                    type: 'bar',
                    data: data,
                    plugins: [ChartDataLabels],
                    options: {
                      animation: {
                        onComplete: () => {
                          delayed = true;
                        },
                        delay: (context) => {
                          let delay = 0;
                          if (context.type === 'data' && context.mode === 'default' && !delayed) {
                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        tooltip: {
                          callbacks: {
                            title: (context) => {
                              const xValue = context[0].label;
                              return `${xValue} horas`; 
                            },
                            label: (context) => {
                              const datasetLabel = context.dataset.label || '';
                              
                              const value = context.raw as number;
                              if (value != null && !isNaN(value)) {
                                return `${datasetLabel}: ${value.toLocaleString(this.userData.region, { maximumFractionDigits: 2 })}`;
                              }
                              return `${datasetLabel}: 0`;
                            }
                          }
                        },
                        legend: {
                          position: "top",
                          labels: {
                            boxWidth: 20,
                            font: {
                              size: 10
                            }
                          }
                        },
                        datalabels: {
                          anchor: 'end',
                          align: 'top',
                          formatter: (value: number, context: any) => {
                            let total = 0;

                            context.chart.data.datasets.forEach((dataset: any, i: number) => {
                              const meta = context.chart.getDatasetMeta(i);
                              if (!meta.hidden) {
                                total += dataset.data[context.dataIndex] || 0;
                              }
                            });

                            const datasetIndex = context.datasetIndex;
                            const dataIndex = context.dataIndex;
                            const meta = context.chart.getDatasetMeta(datasetIndex);
                            const bar = meta.data[dataIndex];

                            const lastVisibleIndex = [...context.chart.data.datasets]
                              .map((_, i) => i)
                              .reverse()
                              .find(i => !context.chart.getDatasetMeta(i).hidden);

                            if (datasetIndex !== lastVisibleIndex) {
                              return '';
                            }

                            return this.formatearConsumo(total); 
                          },
                          font: {
                            weight: 'bold',
                            size: 10
                          },
                          color: '#000',
                          offset: 5,
                        },                                                                                        
                        zoom: {
                          pan: {
                            enabled: true,
                            mode: 'x',
                          },
                          zoom: {
                            wheel: {
                              enabled: true,
                            },
                            pinch: {
                              enabled: true
                            },
                            mode: 'x',
                            onZoomComplete({chart}) {
                              chart.update('none');
                            }
                          },
                        },
                      },
                      interaction: {
                        mode: 'index',
                        intersect: false,
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          position: 'left',
                          title: {
                            display: true,
                            text: 'Litros',
                            font: {
                              size: 13,
                              weight: 'bold'
                            },
                            padding: {
                              bottom: 20
                            },
                          },
                          stacked: true,
                          ticks: {
                            color: "rgba(0,0,0,0.5)",
                            font: {
                              size: 10,
                              weight: 'bold'
                            },
                            padding: 3,
                            callback: function(value, index, values) {
                              return soloDosDecimalesConComa(value);
                            },
                          },
                          grid: {
                            display: false
                          },
                          suggestedMax: function() {
                            const maxDataValue = Math.max(...data.datasets.flatMap((dataset: { data: any; }) => dataset.data));
                            return maxDataValue + (maxDataValue * 0.3);
                          }
                        },
                        x: {
                          title: {
                            display: true,
                            text: 'Horas',
                            font: {
                              size: 13,
                              weight: 'bold'
                            },
                            padding: {
                              top: 20
                            }
                          },
                          stacked: true,
                          ticks: {
                            padding: 5,
                            color: "rgba(0,0,0,0.5)",
                            font: {
                              size: 10,
                              weight: 'bold'
                            },
                          },
                          grid: {
                            display: false
                          }
                        }
                      },
                      elements: {
                        bar: {
                          borderWidth: 2,
                        }
                      }
                    }
                  });
                }else{
                  console.log("No se cargo en el DOM")
                }
            }
          },300)
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.consumosPorHorasCargado = true;
        }
      });
    }

    loadChartTopEstablecimientos(){
      Chart.register(zoomPlugin);
      this.rakingEstablecimientosCambiadaCargarda = false;
      //Destruimos el chart de la gráfica que corresponda
      this.destroyChart(this.chartRanking);
      let establecimientosIds = this.establecimientos.map((obj: any) => obj.id);
      const establecimientoData = new FormData();
      establecimientoData.append('start', moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('end', moment().format('YYYY-MM-DDTHH:mm:ss'));
      establecimientoData.append('establecimientos', JSON.stringify(establecimientosIds));
      establecimientoData.append('desglose', "total");
      this.rankingData1 = [];
      this.topRankingData1 = [];
      this.consumoTotalesTotalesPorCerveza = [];
      this.rankingSubscription = this.deviceService.getEstConsumos(establecimientoData).subscribe({
        next: resp =>{    
          if(resp.length == 0){
            this.rankingEstablecimientosDatos = false;
          } else {
            this.rankingEstablecimientosDatos = true;
            let consumoTotales: { id: number; type: string; consumo: number }[] = [];
            for(let i=0; i<resp.length; i++){
              let consumoTotal1: number = 0;
              consumoTotales = [];
              for (const key in resp[i].beertypes) {
                if (resp[i].beertypes.hasOwnProperty(key)) {
                  const beerType = resp[i].beertypes[key];
                  if (beerType) {
                    const beerID = beerType.id;
                    const beerName = beerType.type;
                    consumoTotal1 += beerType.consume;
                    //Consumo total total
                    const consumo = parseFloat(beerType.consume.toFixed(2));
              
                    // Verificar si ya existe la cerveza en consumosTotales
                    const existingBeerIndex = consumoTotales.findIndex(item => item.type === beerName);
                    const existingBeerIndexTotal = this.consumoTotalesTotalesPorCerveza.findIndex((item: { type: any; }) => item.type === beerName);

                    if (existingBeerIndexTotal !== -1) {
                      // Actualizar consumo si ya existe la cerveza
                      this.consumoTotalesTotalesPorCerveza[existingBeerIndexTotal].consumo += consumo;
                    } else {
                      // Agregar nueva entrada para la cerveza si no existe
                      this.consumoTotalesTotalesPorCerveza.push({ type: beerName, consumo });
                    }

                    // Poner en la gráfica las cervezas que tienen más de 0 consumo
                    if (existingBeerIndex !== -1) {
                      consumoTotales[existingBeerIndex].consumo += parseFloat(beerType.consume.toFixed(2));
                    } else {  
                      consumoTotales.push({ id: beerID, type: beerName, consumo: parseFloat(beerType.consume.toFixed(2)) });
                    }
                    
                  }
                }
              }
              if(this.userData.pro_id == 4){
                consumoTotales = consumoTotales.filter(item => item.consumo > 0);
              }
              const consumoTotalRedondeado = consumoTotal1.toFixed(2);
              const establecimientoRanking: RankingEstablecimientos1 = {
                name: resp[i].name,
                consumosTotales: consumoTotales, // copia para evitar referencias directas
                consumoTotal: parseFloat(consumoTotalRedondeado),
              };
              this.rankingData1.push(establecimientoRanking);
            }
            this.rankingData1.sort((a: { consumoTotal: number; }, b: { consumoTotal: number; }) => b.consumoTotal - a.consumoTotal);
            this.topRankingData1 = this.rankingData1.slice(0, 10);
            if(this.userData.pro_id == 4){
              this.consumoTotalesTotalesPorCerveza = this.consumoTotalesTotalesPorCerveza.filter((item: { consumo: number; }) => item.consumo > 0);
            }

            //CREAR LA GRÁFICA 
            setTimeout(() => {
              if(this.rankingEstablecimientosDatos){
                const canvasRanking: any = document.getElementById('Ranking');
                if(canvasRanking){
                  const ctxRanking = canvasRanking.getContext('2d');
        
                  const labels = [];
                  let datasets: any = []; 
                  const tiposDeCerveza: any = [];
                  for (let j = 0; j < this.topRankingData1.length; j++) {
                    labels.push(this.topRankingData1[j].name);
                    for (let i = 0; i < this.topRankingData1[j].consumosTotales.length; i++) {
                        const cerveza = this.topRankingData1[j].consumosTotales[i];
                        const cervezaInfo = {
                            id: cerveza.id,
                            nombre: cerveza.type
                        };
                        // Verificar si ya hemos agregado esta cerveza por su ID
                        const existingCerveza = tiposDeCerveza.find((item: any) => item.id === cervezaInfo.id);
                        if (!existingCerveza) {
                          tiposDeCerveza.push(cervezaInfo);
                        }
                    }
                  }
                  for(let i=0; i<tiposDeCerveza.length; i++){
                    let data = new Array(this.topRankingData1.length).fill(null); 
                    for(let j=0; j<this.topRankingData1.length; j++){
                      for(let z=0; z<this.topRankingData1[j].consumosTotales.length; z++){
                        const cervezaActual = this.topRankingData1[j].consumosTotales[z];
                        if(cervezaActual.id === tiposDeCerveza[i].id){
                          data[j] = cervezaActual.consumo;
                        }
                      }
                    }
                    // const backgroundColor = i === 0 ? 'rgb(251 176 64)' : '#FFD540';
                    data = data.map(valor => valor === null ? 0 : valor);
                    const colores = ["rgb(251, 176, 64)", "#FFD540", "#FFDE7C"]; 
                    datasets.push({
                      label: tiposDeCerveza[i].nombre, // Nombre de cada tipo de cerveza
                      backgroundColor: i < 2 ? colores[i] : colores[2], 
                      borderWidth: 0,
                      data: data // Consumo de cada tipo de cerveza
                    })
                  }
                  const data = {
                    labels: labels,
                    datasets: datasets,
                  };
                  const soloDosDecimalesConComa = (numero: any) => {
                    return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
                  };
                  // GRÁFICO RANKING ESTABLECIMIENTOS
                  let delayed: any;
                  this.chartRanking = new Chart(ctxRanking, {
                    type: 'bar',
                    data: data,
                    plugins: [ChartDataLabels],
                    options: {
                      animation: {
                        onComplete: () => {
                          delayed = true;
                        },
                        delay: (context) => {
                          let delay = 0;
                          if (context.type === 'data' && context.mode === 'default' && !delayed) {
                            delay = context.dataIndex * 300 + context.datasetIndex * 100;
                          }
                          return delay;
                        },
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        tooltip: {
                          callbacks: {
                            label: (context) => {
                              const datasetLabel = context.dataset.label || '';
                              
                              const value = context.raw as number;
                              if (value != null && !isNaN(value)) {
                                return `${datasetLabel}: ${value.toLocaleString(this.userData.region, { maximumFractionDigits: 2 })}`;
                              }
                              return `${datasetLabel}: 0`;
                            }
                          }
                        },
                        legend: {
                          position: "top",
                          labels: {
                            boxWidth: 20,
                            font: {
                              size: 10
                            }
                          }
                        },
                        datalabels: {
                          anchor: 'end',
                          align: 'top',
                          formatter: (value: number, context: any) => {
                            let total = 0;

                            context.chart.data.datasets.forEach((dataset: any, i: number) => {
                              const meta = context.chart.getDatasetMeta(i);
                              if (!meta.hidden) {
                                total += dataset.data[context.dataIndex] || 0;
                              }
                            });

                            const datasetIndex = context.datasetIndex;
                            const dataIndex = context.dataIndex;
                            const meta = context.chart.getDatasetMeta(datasetIndex);
                            const bar = meta.data[dataIndex];

                            const lastVisibleIndex = [...context.chart.data.datasets]
                              .map((_, i) => i)
                              .reverse()
                              .find(i => !context.chart.getDatasetMeta(i).hidden);

                            if (datasetIndex !== lastVisibleIndex) {
                              return '';
                            }

                            return this.formatearConsumo(total);
                          },
                          font: {
                            weight: 'bold',
                            size: 10
                          },
                          color: '#000',
                          offset: 5,
                        },                           
                        zoom: {
                          pan: {
                            enabled: true,
                            mode: 'x',
                          },
                          zoom: {
                            wheel: {
                              enabled: true,
                            },
                            pinch: {
                              enabled: true
                            },
                            mode: 'x',
                            onZoomComplete({chart}) {
                              chart.update('none');
                            }
                          },
                        },
                      },
                      interaction: {
                        mode: 'index',
                        intersect: false,
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          position: 'left',
                          title: {
                            display: true,
                            text: 'Litros',
                            font: {
                              size: 13,
                              weight: 'bold'
                            },
                            padding: {
                              bottom: 20
                            },
                          },
                          stacked: true,
                          ticks: {
                            color: "rgba(0,0,0,0.5)",
                            font: {
                              size: 10,
                              weight: 'bold'
                            },
                            padding: 3,
                            callback: function(value, index, values) {
                              return soloDosDecimalesConComa(value);
                            },
                          },
                          grid: {
                            display: false
                          },
                          suggestedMax: function() {
                            const maxDataValue = Math.max(...data.datasets.flatMap((dataset: { data: any; }) => dataset.data));
                            return maxDataValue + (maxDataValue * 0.3);
                          }
                        },
                        x: {
                          title: {
                            display: true,
                            text: 'Establecimientos',
                            font: {
                              size: 13,
                              weight: 'bold'
                            },
                            padding: {
                              top: 20
                            }
                          },
                          stacked: true,
                          ticks: {
                            padding: 5,
                            color: "rgba(0,0,0,0.5)",
                            font: {
                              size: 10,
                              weight: 'bold'
                            },
                          },
                          grid: {
                            display: false
                          }
                        }
                      },
                      elements: {
                        bar: {
                          borderWidth: 2,
                        }
                      }
                    }
                  });
                }else {
                  console.log("No se cargo el canvas en el DOM")
                }
              }
            },300)
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.rakingEstablecimientosCambiadaCargarda = true;
        }
      });
    }

    conseguirHoraEnFecha(fecha:string) {
      const dateTimeString = fecha;
      const dateObj = new Date(dateTimeString);
      const hour = dateObj.getHours().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
      const minute = dateObj.getMinutes().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
      const timeString = `${hour}:${minute}`;
      return timeString;
    }

}

@Component({
  selector: 'recargas-dialog',
  templateUrl: 'recargas-dialog.html',
  styleUrls: ['./recargas-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule
  ],
})
export class RecargasDialog {

  waitAfterSave: boolean = false;
  tanquesConAlarmasNivel: any[];
  establecimientos: any[];
  pedidos: any = [];
  recargas: any = [];
  errorMessage : string ="";
  pro_id: any;

  private agregarPedidoSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  constructor(public dialogRef: MatDialogRef<RecargasDialog>, public dialogRefRealizarRecarga: MatDialogRef<RealizarRecargaDialog>, @Inject(MAT_DIALOG_DATA) data: any, private dialog: MatDialog,
  private deviceService : DeviceService, private toastr: ToastrService, private error429: Error429Service) {
    this.tanquesConAlarmasNivel = data.tanquesConAlarmasNivel;
    this.establecimientos = data.establecimientos;
    this.pro_id = data.pro_id
  }

  ngOnDestroy(): void {
    this.limpiarSeleccion();
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
  }

  changeDotToComma(value: any): string {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return value; // Devuelve el valor original si no es un número
    }
  
    return Number(value).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  limpiarSeleccion(): void {
    this.tanquesConAlarmasNivel.forEach(tanque => {
      tanque.seleccionado = false;
    });
  }

  cargarPedidosyRecargas(){
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
        next:resp =>{
          this.pedidos = resp.orders;
          this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete:()=>{
          const establecimientosIDs: any = [];
          for(let x = 0; x < this.establecimientos.length; x++){
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
            },error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            },complete: () => {
              resolve();
            }
          });
        } 
      });
    })
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  async recargarTanque(estID: any, tankID: any){
    this.waitAfterSave = false;
    let hacerPedido: boolean = false;
    let mensajeDeErrorPersonalizado = "Ya existe el pedido";

    await this.cargarPedidosyRecargas()
    // Comprobar que si el pedido ya se ha realizado y no se ha recibido ninguna recarga
      const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tankID);
      const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
      const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tankID);
      const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

      // Si no hay recargas ni pedidos, se hace
      if (!recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si hay un pedido pero no recarga, NO se hace
      else if (!recargaMasAntigua && pedidoMasAntiguo) {
        hacerPedido = false;
      }
      // Si hay recarga pero no hay pedidos, se hace
      else if (recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si la ultima recarga es más reciente o igual al ultimo pedido, se hace
      else if (recargaMasAntigua.created_at >= pedidoMasAntiguo.created_at) {
        hacerPedido = true;
      }
      // Si el último pedido fue después de la última recarga, NO se hace
      else {
        hacerPedido = false;
      }

    if(!hacerPedido){
      if (!this.waitAfterSave) {
        this.waitAfterSave = true;
      }
      setTimeout(() => {
        this.waitAfterSave = false;
      },4500)
      this.toastr.error(mensajeDeErrorPersonalizado, 'Error', {
        timeOut: 4500,
        progressBar: true,
        titleClass: 'toast-family-font'
      });
    } else {
      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', estID.toString());
      pedido.append('tank_id', tankID.toString());
      pedido.forEach((value, key) => console.log(key, value));
      this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
        next:resp =>{
          // console.log(resp);
        }, error: err => {
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          },4500)
          if(err.error.status == 401){
            this.toastr.error("Acción no permitida", 'Error', {
              timeOut: 4500,
              progressBar: true,
              titleClass: 'toast-family-font'
            });
          } else {
            if(err.error.error){
              this.toastr.error(err.error.error, 'Error', {
                timeOut: 4500,
                progressBar: true,
                titleClass: 'toast-family-font'
              });
            } else {
              this.toastr.error('', 'Error', {
                timeOut: 4500,
                progressBar: true,
                titleClass: 'toast-family-font'
              });
            }
          }
        }, complete: () => {
          this.toastr.success('¡Pedido solicitado!','Éxito',{
            timeOut: 4500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
          
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          },4500)
        }
      });
    }
  }

  toggleSeleccion(alarma: any) {
    alarma.seleccionado = !alarma.seleccionado;
  }

  tanquesSeleccionados(): any[] {
    return this.tanquesConAlarmasNivel.filter(t => t.seleccionado);
  }

  recargarSeleccionados() {
    const seleccionados = this.tanquesSeleccionados();

    this.dialog.open(RealizarRecargaDialog, {
      width: '400px',
      data: { 
        total: seleccionados.length,
        seleccionados: seleccionados,
        establecimientos: this.establecimientos,
      }
    });
  }
}

@Component({
  selector: 'consumo-detallado-dialog',
  templateUrl: 'consumo-detallado-dialog.html',
  styleUrls: ['./consumo-detallado-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterModule
  ],
})
export class ConsumoDetalladoDialog {

  constructor(public dialogRef: MatDialogRef<ConsumoDetalladoDialog>, @Inject(MAT_DIALOG_DATA) public consumos: any,){
    // console.log("Consumos", consumos);
  }

}

@Component({
  selector: 'realizar-recarga-dialog',
  templateUrl: 'realizar-recarga-dialog.html',
  styleUrls: ['./realizar-recarga-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatProgressBarModule
  ],
})
export class RealizarRecargaDialog {

  procesados = 0;
  totalSeleccionados = 0;
  seleccionados: any;
  progresado = 0;
  establecimientos: any[];
  pedidosHechos: any = [];
  errores: any = [];
  recargados: any = [];
  pedidos: any = [];
  recargas: any = [];
  errorMessage : string ="";
  titulo = "Enviando pedidos"

  private agregarPedidoSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  constructor(public dialogRefRealizarRecarga: MatDialogRef<RealizarRecargaDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private deviceService : DeviceService, private error429: Error429Service){
    this.totalSeleccionados = data.total;
    this.establecimientos = data.establecimientos;
    this.seleccionados = data.seleccionados;
    this.iniciarRecarga();
  }

  async iniciarRecarga() {
    for (let index = 0; index < this.seleccionados.length; index++) {
      const tanque = this.seleccionados[index];
      await this.recargarTanque(tanque.tankJson.custom_num, tanque.establishment_name,  tanque.establishment_id, tanque.tankJson.id, index);
    }
    setTimeout(() => {
      this.titulo = "Pedidos enviados";
    }, 300);
  }
  
  ngOnDestroy(): void {
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  cargarPedidosyRecargas(){
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
        next:resp =>{
          this.pedidos = resp.orders;
          this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete:()=>{
          const establecimientosIDs: any = [];
          for(let x = 0; x < this.establecimientos.length; x++){
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
            },error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            },complete: () => {
              resolve();
            }
          });
        } 
      });
    })
  }

  async recargarTanque(numTank: any, estName:any, estID: any, tankID: any, index: any){
    this.procesados = index + 1;
    let hacerPedido: boolean = false;

    await this.cargarPedidosyRecargas()

      const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tankID);
      const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
      
      const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tankID);
      const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

      // Si no hay recargas ni pedidos, se hace
      if (!recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si hay un pedido pero no recarga, NO se hace
      else if (!recargaMasAntigua && pedidoMasAntiguo) {
        hacerPedido = false;
      }
      // Si hay recarga pero no hay pedidos, se hace
      else if (recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si la ultima recarga es más reciente o igual al ultimo pedido, se hace
      else if (recargaMasAntigua.created_at >= pedidoMasAntiguo.created_at) {
        hacerPedido = true;
      }
      // Si el último pedido fue después de la última recarga, NO se hace
      else {
        hacerPedido = false;
      }

    if(!hacerPedido){
      this.pedidosHechos.push({ numTank: numTank, nombre: estName });
      this.progresado = (this.procesados / this.totalSeleccionados) * 100;
    } else {
      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', estID.toString());
      pedido.append('tank_id', tankID.toString());
      pedido.forEach((value, key) => console.log(key, value));
      this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
        next:resp =>{
          console.log(resp);
          this.recargados.push({ numTank: numTank, nombre: estName });
          this.progresado = (this.procesados / this.totalSeleccionados) * 100;
        }, error: err => {
          this.errores.push({ numTank: numTank, nombre: estName });
          this.progresado = (this.procesados / this.totalSeleccionados) * 100;
        }, complete: () => {
        }
      });
    }
  }

}

interface RankingEstablecimientos{
  name: string;
  consumoTotalEstrella: number;
  consumoTotal1906: number;
  consumoTotalAlouminha: number;
  consumoTotal: number;
}
interface RankingEstablecimientos1 {
  name: string;
  consumosTotales: { id: number, type: string; consumo: number }[];
  consumoTotal: number;
}

interface Tank {
  id: number;
  prediction_days?: number;
  consumption_rate?: number;
}

interface Establecimiento {
  tankJson: Tank;
}